const initialState = {
  menuOpen: false,
  terminalOpen: false,
  location: {},
  pageTree: [],
  pageList: [],
};

export default initialState;
